export default (that) => [
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    title: that.$l('table_label_displayStoreNo') || '店铺',
    field: 'amzStoreNo',
    minWidth: 200,
    align: 'left',
    headerAlign: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayStoreNo' },
  },
]
